/*
  This is where the magic happens and creates the custom field extension.
*/

import {
    scaffolderPlugin,
    createScaffolderFieldExtension,
} from '@backstage/plugin-scaffolder';
import { reponameValidationExtension, reponameValidation } from './reponameValidationExtension';


export const RepoNameValidation = scaffolderPlugin.provide(

    createScaffolderFieldExtension({
        name: 'reponameValidationExtension',
        component: reponameValidationExtension,
        validation: reponameValidation,
    }),
);